import { THEODORE_GET_EMAIL_OTP_SUCCESS, THEODORE_GET_EMAIL_OTP_FAILURE, THEODORE_RESET_PASSWORD_SUCCESS, THEODORE_RESET_PASSWORD_FAILURE } from './action';

const initialState = {
    theodoreGetOtpSuccess: {},
    theodoreForgotPasswordFailure: {},
    theodoreResetPasswordSuccess: {},
    theodoreResetPasswordFailure: {}
}

const forgotTheodorePasswordReducer = (state = initialState, action) => {
    switch (action.type) {
        case THEODORE_GET_EMAIL_OTP_SUCCESS:
            return state = {
                ...state,
                theodoreGetOtpSuccess: action.data
            }
        case THEODORE_GET_EMAIL_OTP_FAILURE:
            return state = {
                ...state,
                theodoreForgotPasswordFailure: action.data
            }
        case THEODORE_RESET_PASSWORD_SUCCESS:
            return state = {
                ...state,
                theodoreResetPasswordSuccess: action.data
            }
        case THEODORE_RESET_PASSWORD_FAILURE:
            return state = {
                ...state,
                theodoreResetPasswordFailure: action.data
            }
        default: return state
    }
}
export default forgotTheodorePasswordReducer;